import Vue from "vue";
import bigButton from "@/components/button";
import datePicker from "@/components/picker";
import addressAlert from "@/components/address_alert";

Vue.component("bigButton", bigButton);
Vue.component("datePicker", datePicker);
Vue.component('addressAlert', addressAlert);
